import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }

  var swiper2 = new Swiper(".swiper2 .mySwiper", {
    slidesPerView: 2,
    spaceBetween: 10,
    breakpoints: { //响应式
      768: {  //当屏幕宽度大于等于768 
        slidesPerView: 3,
        spaceBetween: 10
      },
      1024: {  //当屏幕宽度大于等于768 
        slidesPerView: 4,
        spaceBetween: 20
      },
      1280: {  //当屏幕宽度大于等于1280
        slidesPerView: 5,
        spaceBetween: 30
      }
    }
  })

  var swiper1 = new Swiper(".swiper1 .mySwiper", {
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    navigation: {//按钮
      nextEl: ".swiper2 .swiper-button-next",
      prevEl: ".swiper2 .swiper-button-prev",
    },
    on:{
      init: function(swiper){
        swiper2.slideTo(this.realIndex)
        $('.swiper2 .swiper-slide').eq(this.realIndex).addClass('active')
      },
      slideChangeTransitionStart: function(){
        swiper2.slideTo(this.realIndex)
        $('.swiper2 .swiper-slide').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    }
  })
  $('.swiper2 .swiper-slide').on('click',function(){
    let index = $(this).index()
    swiper1.slideTo(index)
  })
})